import { ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { authorizationFetch } from '@/api/payManage/appManage';
import { OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppAddAuthModal',
  props: {
    modalVisible: {
      type: Boolean
    }
  },
  emits: ['update:modalVisible', 'refresh'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = ref(false),
      loading = ref(false),
      formRef = ref(),
      formValue = ref({
        dbtId: undefined
      }),
      rules = ref({
        dbtId: [{
          required: true,
          message: '请输入dbtId',
          trigger: 'blur'
        }]
      });
    const closeModal = () => {
      var _formRef$value, _formRef$value2;
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.clearValidate();
      (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 || _formRef$value2.resetFields();
      emit('update:modalVisible', false);
    };
    const handleOk = () => {
      var _formRef$value3;
      (_formRef$value3 = formRef.value) === null || _formRef$value3 === void 0 || _formRef$value3.validate().then(() => {
        addAppAuth();
      }).catch(error => {});
    };
    const addAppAuth = async () => {
      try {
        loading.value = true;
        const {
          code
        } = await authorizationFetch({
          dbtIds: [formValue.value.dbtId]
        });
        if (code === OK) {
          message.success('添加成功');
          closeModal();
          emit('refresh');
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '产品管理',
              element_name: '添加产品授权'
            }
          });
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    };
    watch(() => props.modalVisible, n => {
      visible.value = n;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[1] || (_cache[1] = $event => visible.value = $event),
        title: "添加产品授权",
        width: "650px",
        centered: "",
        "ok-text": "提交",
        "confirm-loading": loading.value,
        onOk: handleOk,
        onCancel: closeModal,
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "formRef",
          model: formValue.value,
          ref_key: "formRef",
          ref: formRef,
          rules: rules.value
        }, {
          default: _withCtx(() => [_createVNode(_component_a_row, {
            gutter: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "DbtId",
                name: "dbtId"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: formValue.value.dbtId,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => formValue.value.dbtId = $event),
                  placeholder: "请输入DbtId"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});